var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "subscription-filter flex flex-wrap gap-3 items-end mb-2 pb-4",
    },
    [
      _c(
        "div",
        {
          staticClass: "w-full sm:w-auto flex-grow",
          staticStyle: { "min-width": "200px" },
        },
        [
          _c("select-suggestion", {
            attrs: {
              column: "name,email",
              model: "User",
              label: _vm.$t("subscription.user"),
              appendClearOption: true,
              itemTextFormat: _vm.formatUserNameEmailHtml,
              "dropdown-options-class": "user-suggest-dropdown",
              placeholderText: "Digite o nome ou e-mail do usuário",
            },
            on: { input: _vm.emitFilters },
            model: {
              value: _vm.selectedUser,
              callback: function ($$v) {
                _vm.selectedUser = $$v
              },
              expression: "selectedUser",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "w-full sm:w-auto flex-grow",
          staticStyle: { "min-width": "180px" },
        },
        [
          _c("label", { staticClass: "text-sm font-medium mb-1 block" }, [
            _vm._v(_vm._s(_vm.$t("subscription.status"))),
          ]),
          _c(
            "v-select",
            {
              staticClass: "w-full",
              attrs: {
                options: _vm.statusOptions,
                reduce: function (opt) {
                  return opt.value
                },
                label: "label",
                placeholder: _vm.$t("subscription.status") + " - Todos",
              },
              on: { input: _vm.emitFilters },
              model: {
                value: _vm.selectedStatus,
                callback: function ($$v) {
                  _vm.selectedStatus = $$v
                },
                expression: "selectedStatus",
              },
            },
            [
              _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
                _vm._v(_vm._s(_vm.$t("subscription.no_statuses"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex items-end shrink-0 ml-3" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger", size: "sm" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" " + _vm._s(_vm.$t("action.clear")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }